/**
 * Creates a simple way to subscribe and listen to events.
 *
 * Example:
 * const [subscribe, unsubscribe, notify] = createPubSub();
 *
 * subscribe((message) => { console.log(message) })
 *
 * notify("hello")
 * => "hello"
 */
export default function createPubSub() {
  let listeners = []

  const subscribe = callback => {
    listeners.push(callback)
  }

  const unsubscribe = callback => {
    listeners = listeners.filter(listener => listener !== callback)
  }

  const notify = message => {
    listeners.forEach(listener => {
      listener(message)
    })
  }

  return [subscribe, unsubscribe, notify]
}
